import get from 'lodash.get';
import getSiteData from './site-data';

const getSiteTemplateSlug = (rootState) => {
  const siteData = getSiteData(rootState);
  return get(siteData, 'templateSlug', null);
};

export default getSiteTemplateSlug;
